import './style.scss';

export function faqs_cta_block() {
    const block = document.querySelector('.faqs_cta_block');
    if (!block) return;
}

